module.exports = __webpack_public_path__ + "img/whitedownarr.e8de07ca.svg";